
function isNameConsultUrl (name) {
  return name === '相談 URL'
}

function isInstantMessageTypeTicket (type) {
  return type === 'TICKET'
}

export default {
  isNameConsultUrl,
  isInstantMessageTypeTicket
}



// WEBPACK FOOTER //
// ./src/components/menus/ticket/util/kakaoInstantMessageUtil.js